import React, { useState, useEffect } from 'react'
import accounting from 'accounting'
import { useTranslation } from 'react-i18next'

import Banner from 'components/Banner.js'
import Progress from 'components/Progress.js'
import { getDate } from 'utils/dateTime.js'

import { isLimitedConstraint, isShowDanger, getViewConstraints } from './utils'

const ViewsCountBanner = ({ subscription, isVisible }) => {
    const { t } = useTranslation()
    const [viewsConstraints, setViewsConstraints] = useState(() => getViewConstraints(subscription))

    useEffect(() => {
        setViewsConstraints(getViewConstraints(subscription))
    }, [subscription])

    const isUnlimitedPlan = isLimitedConstraint(viewsConstraints)
    if (!isUnlimitedPlan || !isVisible) return null

    if (isShowDanger(viewsConstraints)) {
        return (
            <Banner
                variant="danger"
                padding="normal"
                reason_id={2}
                reason_data={{
                    current: accounting.formatNumber(viewsConstraints.value, {
                        thousand: ' ',
                    }),
                    total: accounting.formatNumber(viewsConstraints.total, { thousand: ' ' }),
                }}
            />
        )
    }

    return (
        <Progress
            value={viewsConstraints.value}
            total={viewsConstraints.total}
            title={t('Views by all projects')}
            date={`${getDate(viewsConstraints.start)} - ${getDate(viewsConstraints.end)}`}
            units={t('views')}
        />
    )
}

export default ViewsCountBanner
